import React from 'react';
import {getBackwardTextLimitBy} from "../../../commonmethod/CommonMethod";
import Noimage from "../../../../resources/icon/noImage.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUser} from "@fortawesome/free-solid-svg-icons";

function AssetInfoSlide({data}) {
    const IMG_BASE = import.meta.env.VITE_IMG_BASE
    return (
        <div className={'flex'}>
            <div className="thumbnail-img mt-[25px]">
                {data.images ?
                    <img className="w-[40px] block " src={
                        data.images[0].thumbnail && data.images[0].thumbnail ? IMG_BASE + data.images[0].path + "thumb_" + data.images[0].uploadName :
                            IMG_BASE + data.images[0].path + data.images[0].uploadName
                    } alt={"이미지 설명"}/>
                    :
                    <img src={Noimage} className="w-[40px]"/>
                }
            </div>

            <div className={"thumb-each-info"}>
                <table className={"w-full thumb-table"}>
                    <tbody>
                    <tr className={"h-[25px]"}>
                        <th>자산명</th>
                        <td className="thumb-tr">{data.assetName.length > 24 ? data.assetName.substring(0, 23) + "..." : data.assetName}</td>
                    </tr>
                    <tr className={"thumb-tr"}>
                        <th>자산코드</th>
                        <td className="">{data.assetCode}</td>
                    </tr>
                    <tr className={""}>
                        <th className="t">
                            <p> [ 운영 <FontAwesomeIcon icon={faUser} className={`line-height-30`}/> ]</p>
                            <p> [ 자산 <FontAwesomeIcon icon={faUser} className={`line-height-30`}/> ]</p>
                        </th>
                        <td>
                            <p> {data.operator?.name}</p>
                            <p> {data.handler?.name}</p>
                        </td>
                    </tr>

                    <tr className={"thumb-tr"}>
                        <td colSpan="2">
                            {data.group &&
                                <span
                                    className="thumb-ag text-[11px] px-[8px] py-[3px] mr-1">{getBackwardTextLimitBy(data.group.name, 8)}</span>
                            }
                            {data.task &&
                                <span
                                    className="thumb-at text-[11px] px-[8px] py-[3px] mr-1">{getBackwardTextLimitBy(data.task.name, 9)}</span>
                            }
                            {data.project &&
                                <span
                                    className="thumb-pc text-[11px] px-[8px] py-[3px]">{getBackwardTextLimitBy(data.project.name, 15)}</span>
                            }
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default AssetInfoSlide;